import React from "react";
import { useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import { useTranslation } from "react-i18next";
import AssignedAssessmentsListRow from "./AssignedAssessmentsListRow";

const AssignedAssessmentsList = () => {
  const { t } = useTranslation();
  const tickets = useSelector((state) => state.candidate.candidate.tickets || []);
  const reversedTickets = tickets.slice().reverse();

  return (
    <Row className="mx-0 mt-2">
      {tickets.length > 0 ? (
        <Col>
          {reversedTickets.map((ticket, index) => (
            <AssignedAssessmentsListRow ticket={ticket} key={index} />
          ))}
        </Col>
      ) : (
        <Col>
          <Card className="default-card py-3 px-4" style={{ backgroundColor: "#f7f7f7" }}>
            <Row className="justify-content-center">
              <Col xs="auto" className="text-20 text-color-gray-light fw-medium">
                {t("assignedAssessmentsEmptyLabel")}
              </Col>
            </Row>
          </Card>
        </Col>
      )}
    </Row>
  );
};

export default AssignedAssessmentsList;
